import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"ember-primitives\"}}\n\n<Layout />",{ moduleName: "docs-app/templates/application.hbs" })